import React, { useState, useEffect } from 'react';
import './Dashboard.css'; // Import the CSS file for styles
import '@fortawesome/fontawesome-free/css/all.min.css'
import PopupMultiform from '../component/PopupMultiform';
import CreativeStepPopup from './popup/CreativeStepPopup';
import "./popup/style/CreativeStyle.css";
import myimg from './earth.png';
import undo from './undo.png';
import floppy from './floppy.png';
import campaignicon from './campaignicon.png';
import mycompass from './compassicon.png';
import CreativeStepPopup2 from './popup/CreativeStepPopup2';
import fasend from "./fasend.png";


interface DailyMetric {
  id: number;
  campaign_id: number;
  date: string;
  visitors: number;
  bid_requests: number;
  cost: string;
  cpc: string; // Already calculated CPC from the API
}

// Interfaces for Campaign, Bidding, and Creative
interface Campaign {
  id: number;
  campaign_name: string;
  ad_format: string;
  geo: string;
  traffic_source_type: string;
  bid: string;
  daily_cap: string;
  cost: string;
  impressions: number;
  clicks: number;
  conversions: number;
  win_rate: string;
  video_impressions: number;
}

interface Bidding {
  campaign_id: number;
  bid: string;
  daily_cap: string;
  cost: string;
}

interface Creative {
  creative_id: number;
  campaign_id: number;
  ad_name: string;
  title: string;
  description_1: string;
  description_2: string;
  display_url: string;
  destination_url: string;
}

const DefaultPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [bidding, setBidding] = useState<Bidding[]>([]);
  const [creatives, setCreatives] = useState<Creative[]>([]);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [noData, setNoData] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>('Today');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedFilter, setSelectedFilter] = useState<string>('Select a Filter');
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [currentEditData, setCurrentEditData] = useState<Campaign | null>(null);
  const [currentEditId, setCurrentEditId] = useState<number | null>(null);
  const [isEditModalOpen1, setIsEditModalOpen1] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [currentEditId1, setCurrentEditId1] = useState<number | null>(null);
  // State to track which row is clicked
  const [clickedIndex, setClickedIndex] = useState<number | null>(null);
  // State to track which row is hovered
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [dailyMetrics, setDailyMetrics] = useState<DailyMetric[]>([]);
  const [currentAdFormat, setCurrentAdFormat] = useState<string | null>(null);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null); // Allow string | null
  const [selectedId2, setSelectedId2] = useState<number | null>(null); // Allow string | null

  // const handleClick = (id) => {
  //   setSelectedId(selectedId === id ? null : id); // Toggle based on ID
  // };



  const defaultStartDate = "2024-01-01";
  const defaultEndDate = "2025-02-27";

  const [colors, setColors] = useState<{ [key: string]: string }>({
    [3]: '#D3D3D3', // Initial color for this icon
  });

  const handleClick = (id: string) => {
    setColors(prevColors => ({
      ...prevColors,
      [id]: prevColors[id] === "#D3D3D3" ? "black" : "#D3D3D3", // Toggle color
    }));

  };

  const handleClick2 = (id: number) => {

    setSelectedId(prevId => (prevId === id ? null : id)); // Toggle based on ID

  };
  const handleClick3 = (id: number) => {

    setSelectedId2(prevId => (prevId === id ? null : id)); // Toggle based on ID

  };


  // Function to handle row click and set the clicked index
  const handleRowClick = (index: number) => {
    setClickedIndex(index);
  };


  // Function to handle hover start
  const handleMouseEnter = (index: number) => {
    setHoveredIndex(index);
  };

  // Function to handle hover end
  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };


  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL;


  const handleMouseOver = (id: number) => {
    document.getElementById(`cog1_${id}`)!.className =
      document.getElementById(`cog2_${id}`)!.className =
      document.getElementById(`cog3_${id}`)!.className =
      "fa fa-cog fa-spin";
  };

  const handleMouseOut = (id: number) => {
    document.getElementById(`cog1_${id}`)!.className =
      document.getElementById(`cog2_${id}`)!.className =
      document.getElementById(`cog3_${id}`)!.className =
      "fa fa-cog";
  };

  const [formData, setFormData] = useState({
    dailyCap: "",
    adName: "",
    title: "",
    description1: "",
    description2: "",
    displayURL: "",
    destinationURL: "",
    trafficSourceType: "",
    frequencyFilter: "",
  });



  const filterOptions = [
    'Select a Filters',
    'Traffic',
    'Geos',
    'Bid Range',
    'Type',
    'Status',
    'Device',
    'Editorial',
    'Requests',
    'Visits',
    'CTR',
    'Cost',
    'Archived',
    'Total Conversions',
    'Conversion Rate',
  ];

  const options = [
    'Today',
    'Yesterday',
    'Last 7 days',
    'This Month',
    'Last Month',
    'Last 30 days',
    'Select Date Range',
  ];


  // Function to calculate date ranges
  const calculateDateRange = (option: string) => {
    const today = new Date();
    let start: Date;
    let end: Date;

    switch (option) {
      case "Today":
        start = new Date(today);
        end = new Date(today);
        break;

      case "Yesterday":
        start = new Date(today);
        start.setDate(today.getDate() - 1);
        end = new Date(today);
        end.setDate(today.getDate() - 1);
        break;

      case "Last 7 days":
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = new Date(today);
        break;

      case "This Month":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today);
        break;

      case "Last Month":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
        break;

      case "Last 30 days":
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = new Date(today);
        break;

      case "Select Date Range":
        alert("Please select a custom date range from the calendar.");
        return;

      default:
        return;
    }

    // Update the state
    setStartDate(start.toISOString().split("T")[0]); // Format as YYYY-MM-DD
    setEndDate(end.toISOString().split("T")[0]);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedFilter(event.target.value);
  };

  // Handle change of the dropdown
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const option = event.target.value;
    setSelectedOption(option);
    calculateDateRange(option);
  };

  const fetchDataById = async (id: number) => {
    try {
      // Check if we're on localhost or on the production site (bidvertiserdemo.vercel.app)
      const baseUrl = window.location.hostname === 'localhost'
        ? `http://localhost:5000/api/creatives/getCreativeById/${id}`
        : `https://bidvertiser-api.vercel.app/api/creatives/getCreativeById/${id}`;

      const response = await fetch(baseUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch data for ID ${id}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching data by ID:', error);
      throw error;
    }
  };


  const fetchData = async () => {
    // // Check if both startDate and endDate are provided
    // if (!startDate || !endDate) {
    //   alert('Please select both start and end dates.');
    //   return;
    // }



    console.log(`Fetching data from ${startDate} to ${endDate}`);
    try {


      const isDateEmpty = !startDate || !endDate;

      const baseUrl = window.location.hostname === "localhost"
        ? `http://localhost:5000/api/alldata/allDataTime?startDate=${isDateEmpty ? defaultStartDate : startDate
        }&endDate=${isDateEmpty ? defaultEndDate : endDate}`
        : `https://bidvertiser-api.vercel.app/api/alldata/allDataTime?startDate=${isDateEmpty ? defaultStartDate : startDate
        }&endDate=${isDateEmpty ? defaultEndDate : endDate}`;


      const apiUrl = `${baseUrl}`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Fetched data:', data);

      // Handle cases when no data is returned
      if (data.campaigns.length === 0 && data.dailyMetrics.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
      }

      // Set the data into the state
      setCampaigns(data.campaigns);
      setBidding(data.bidding);
      setCreatives(data.creatives);
      setDailyMetrics(data.dailyMetrics);

      // Call calculateTotals and pass the campaigns data
      const totals = calculateTotals(campaigns, dailyMetrics);

    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [defaultStartDate, defaultEndDate]);


  // const calculateTotals = (data: Campaign[]) => {
  //   let totalBidRequests = 0;
  //   let totalCost = 0;
  //   let totalImpressions = 0;
  //   let totalClicks = 0;
  //   let totalDailyCap = 0;
  //   let totalWinRate = 0;

  //   campaigns.forEach((campaign: Campaign) => {
  //     totalBidRequests += Number(campaign.impressions);
  //     totalCost += Number(campaign.cost);
  //     totalImpressions += (["Video Ad", "Native Ad"].includes(campaign.ad_format) ? Number(campaign.video_impressions) : 0);
  //     totalClicks += (!["Video Ad", "Native Ad"].includes(campaign.ad_format) ? Number(campaign.clicks) : 0);
  //     totalDailyCap += Number(campaign.daily_cap);
  //     totalWinRate += Number(campaign.win_rate);
  //   });

  //   return { totalCost, totalImpressions, totalClicks, totalDailyCap, totalBidRequests, totalWinRate };
  // };

  const calculateTotals = (campaigns: Campaign[], dailyMetrics: DailyMetric[]) => {
    let totalVisitors = 0;
    let totalCost = 0;
    let totalDailyCap = 0;

    let totalBidRequestsVideo = 0;
    let totalBidRequestsNonVideo = 0;
    let totalImpressionsVideo = 0;
    let totalImpressionsNonVideo = 0;
    let totalClicks = 0; // Combined clicks

    campaigns.forEach((campaign) => {
      const metrics = dailyMetrics.filter((m) => m.campaign_id === campaign.id);

      totalVisitors += metrics.reduce((sum, metric) => sum + metric.visitors, 0);
      totalDailyCap += Number(campaign.daily_cap);
      totalCost += metrics.length > 0
        ? metrics.reduce((sum, metric) => sum + parseFloat(metric.cost), 0)
        : parseFloat(campaign.cost);

      const isVideoAd = ["Video Ad"].includes(campaign.ad_format);

      if (isVideoAd) {
        totalBidRequestsVideo += metrics.reduce((sum, metric) => sum + metric.bid_requests, 0);
        totalImpressionsVideo += Number(campaign.video_impressions);
      } else {
        totalBidRequestsNonVideo += metrics.reduce((sum, metric) => sum + metric.bid_requests, 0);
        totalImpressionsNonVideo += Number(campaign.impressions);
      }

      // Combine clicks for both types
      totalClicks += Number(campaign.clicks);
    });

    // Calculate Win Rate
    const totalBidRequests = totalBidRequestsVideo + totalBidRequestsNonVideo;
    const winRate = totalBidRequests === 0 ? "0.00%" : ((totalVisitors / totalBidRequests) * 100).toFixed(2) + "%";

    return {
      totalVisitors,
      totalCost,
      totalDailyCap,
      totalBidRequestsVideo,
      totalBidRequestsNonVideo,
      totalImpressionsVideo,
      totalImpressionsNonVideo,
      totalClicks, // Combined Clicks
      winRate
    };
  };





  const totals = calculateTotals(campaigns, dailyMetrics);

  // Aggregate metrics for each campaign (no need to recalculate CPC)
  const aggregateMetrics = (campaign: Campaign) => {
    const metrics = dailyMetrics.filter((m) => m.campaign_id === campaign.id);

    // Aggregate values
    const totalVisitors = metrics.reduce((sum, metric) => sum + metric.visitors, 0);
    const totalBidRequests = metrics.reduce((sum, metric) => sum + metric.bid_requests, 0);
    const totalCost = metrics.reduce((sum, metric) => sum + parseFloat(metric.cost), 0);

    // If there are no daily metrics, fall back to campaign cost
    const finalCost = metrics.length > 0 ? totalCost : parseFloat(campaign.cost);

    // Calculate Win Rate
    const winRate =
      totalBidRequests === 0 ? "0.00%" : ((totalVisitors / totalBidRequests) * 100).toFixed(2) + "%";

    return {
      totalVisitors,
      totalBidRequests,
      totalCost: finalCost,
      winRate, // Added Win Rate
    };
  };




  // Function to save data as CSV
  const saveDataAsCSV = () => {
    if (campaigns.length === 0) {
      alert('No data available to save.');
      return;
    }

    const csvRows = [];
    const headers = ['Actions', 'Status', 'Ad Format', 'ID', 'Campaign Name', 'Ad Name', 'Your Bid (US$)', 'GEO', 'Bid Requests', 'Video Imp.', 'Visits', 'Win Rate', 'Cost', 'Daily Cap'];
    csvRows.push(headers.join(','));

    campaigns.forEach((campaign) => {
      const adNames = creatives
        .filter((creative) => creative.campaign_id === campaign.id)
        .map((creative) => creative.ad_name)
        .join('; ');

      const row = [
        '⚙️',
        '', // Status
        campaign.ad_format,
        campaign.id,
        campaign.campaign_name,
        adNames, // Ad Names for the campaign
        campaign.bid,
        campaign.geo,
        campaign.impressions,
        campaign.video_impressions,
        campaign.clicks,
        campaign.win_rate,
        campaign.cost,
        campaign.daily_cap,
      ];
      csvRows.push(row.join(','));
    });

    const csvData = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.setAttribute('href', csvUrl);
    link.setAttribute('download', 'campaigns.csv');
    link.click();
  };

  const clearData = () => {
    setCampaigns([]);
    setNoData(false);
  };


  const handleEdit = (id: number) => {
    console.log("Opening popup for campaign ID:", id); // Debugging log
    setCurrentEditId1(id); // Set the currentEditId to the clicked campaign's ID
    setIsEditModalOpen(true); // Open the edit modal
  };

  // Handle updates from the popup
  const handleUpdate = async (updatedData: Campaign) => {
    try {
      const baseUrl = window.location.hostname === 'localhost'
        ? `http://localhost:5000/api/campaigns/updateCampaign`
        : `https://bidvertiser-api.vercel.app/api/campaigns/updateCampaign`;

      // Construct the API URL with the date range query parameters
      const apiUrl = `${baseUrl}`;



      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedData),
      });
      if (!response.ok) throw new Error("Failed to update campaign");

      alert("Campaign updated successfully!");
      setIsEditModalOpen(false); // Close the modal
      fetchData(); // Refresh the campaign list
    } catch (error) {
      console.error("Error updating campaign:", error);
      alert("Failed to update campaign.");
    }
  };

  const handleDelete = async (id: number) => {
    // Show a confirmation dialog
    const confirmation = window.confirm(
      "Do you really want to delete this ad campaign? It will no longer be available. Click OK to confirm or Cancel to abort."
    );

    // If the user cancels, exit the function
    if (!confirmation) {
      alert("Deletion canceled.");
      return;
    }

    // Proceed with deletion if confirmed
    try {


      const baseUrl = window.location.hostname === 'localhost'
        ? `http://localhost:5000/api/campaigns/deleteCampaign/${id}`
        : `https://bidvertiser-api.vercel.app/api/campaigns/deleteCampaign/${id}`;

      // Construct the API URL with the date range query parameters
      const apiUrl = `${baseUrl}`;



      const response = await fetch(
        apiUrl,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      alert("Campaign deleted successfully!");
      fetchData(); // Refresh the data after deletion
    } catch (error) {
      console.error("Error deleting campaign:", error);
      alert("Failed to delete campaign.");
    }
  };




  // Open the edit modal for campaign updates
  const handleOpenEditModal = (campaign: Campaign) => {
    setCurrentEditData(campaign);
    setIsEditModalOpen(true);
  };




  // CReativeteppopup 
  // Function to handle edit button click
  const handleCreativePopup = (id: number, adFormat: string) => {
    console.log("Opening popup for campaign ID:", id, "Ad Format:", adFormat); // Debugging log
    setCurrentEditId(id);
    setCurrentAdFormat(adFormat);
    setIsEditModalOpen1(true);
  };


  const handleCreativePopup1 = (id: number) => {
    console.log("Opening popup for campaign ID:", id); // Debugging log
    setCurrentEditId1(id);
    setIsEditModalOpen(true);
  };



  // Close the edit modal
  const handleCloseEditModal = () => {
    setCurrentEditId(null);
    setIsEditModalOpen(false);
  };





  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = () => {
    setIsEditModalOpen1(true);
  };

  const handleSave = () => {
    console.log("Saving form data:", formData);
    setIsEditModalOpen(false);
  };



  return (
    <>

      <div className='body'>

        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
        {/* TOp section filter */}
        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}

        <div className="dashboard-header" style={{
          height: '50PX', boxShadow: '0 4px 8px #0000001a', // Increased blur and spread
        }}>

          {/* Date Range */}
          <div className="date-range" style={{
            display: 'flex',
            fontSize: '13px',
            width: '450px',
            border: '1px solid lightgrey',
            boxShadow: 'inset 0 0 10px 1px rgb(0 0 0 / 5%)',
            background: 'rgba(255,255,255,1)',
            backgroundPosition: '0 0',
            fontFamily: "Open Sans', sans-serif",
            minHeight: '25px',
            outline: 'none',
            color: '#505050',
          }}>
            <div>
              {/* Dropdown for date range options */}
              <select
                value={selectedOption}
                onChange={handleChange}
                className="date-picker"
                style={{
                  all: 'unset',
                  textAlign: 'left',
                  paddingLeft: '10px',
                  WebkitAppearance: 'none',
                  boxShadow: 'none',
                  lineHeight: '28px',
                  height: '28px',
                  width: '120px',
                  MozAppearance: 'none',
                  backgroundPosition: 'right',
                  backgroundImage: "url('https://my.bidvertiser.com/BidVertiser/Images/select_FF.png')",
                  backgroundRepeat: 'no-repeat',
                }}
              >
                {options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {/* Date pickers for custom range */}
            <input
              type="date"
              className="date-picker"
              style={{
                all: 'unset',
                borderLeft: '1px dashed grey',
                boxShadow: 'none',
                fontSize: '14px',
                padding: '0 20px 0 10px',
                width: '200px',
                position: 'relative',

              }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />

            <input
              type="date"
              className="date-picker"
              style={{
                all: 'unset',
                borderLeft: '1px dashed grey',
                padding: '0 20px 0 10px',
                fontSize: '14px',
                width: '220px',
                position: 'relative',
              }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />


          </div>
          <button className="btn btn-generate" onClick={fetchData} style={{ fontSize: '14px', backgroundColor: '#81d34a', padding: '7px 14px' }}>
            Generate
          </button>
          {/* Filters and Bulk Actions */}
          <div className="actions">

            <div style={{ position: 'relative' }}>
              {/* Filter Button */}
              <button
                onClick={toggleModal}
                style={{
                  backgroundColor: '#1173B7',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '0px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '14px'

                }}

              >
                <img style={{ width: '14px', marginRight: '4px', marginBottom: '-2px' }} src="https://my.bidvertiser.com/BidVertiser/Images/bdv_action_filter.png" alt="" />Filters
              </button>

              {/* Modal Background */}
              {isModalOpen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 60,
                    left: 100,
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '100px',
                  }}
                >
                  {/* Modal Content */}
                  <div
                    style={{
                      backgroundColor: '#1B3A5E',
                      padding: '10px',
                      borderRadius: '8px',
                      width: '400px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                      position: 'relative',
                      height: '50px'
                    }}
                  >
                    {/* <h4 style={{ marginBottom: '10px', fontSize: '16px', color: '#333' }}>Select a Filter</h4> */}
                    <select
                      value={selectedFilter}
                      onChange={handleFilterChange}
                      style={{
                        width: '40%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        marginBottom: '10px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="Select a Filter" disabled>

                      </option>
                      {filterOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>



                    {/* Close Button */}
                    <button
                      onClick={toggleModal}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'transparent',
                        border: 'none',
                        fontSize: '16px',
                        cursor: 'pointer',
                        color: '#999',
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="btn btn-primary" style={{ fontSize: '14px' }}> <i style={{ marginRight: '5px', fontSize: '14px' }} className='fa fa-asterisk'></i>Bulk Actions</button>

          </div>

          {/* Create New Campaign */}
          <div className="create-campaign" style={{ display: 'block' }}>
            <a href="https://www.mybidvertizer.com/dashboard/CreateCampaign">
              <button className="btn btn-primary" style={{ fontSize: '14px' }}>
                Create new campaign
              </button>
            </a>
          </div>

        </div>

        <div className="dashboard-header" style={{
          width: '100%',
          height: '30px',
          borderTop: '0px',
          justifyContent: 'space-between',
          display: 'flex',
          padding: '0px 24px',
          marginTop: '-0.8px',
          boxShadow: '0 4px 8px #0000001a'

        }}>

          <div id="container" className="flex-container">
            <div className="icon-container">
              <i className="fas fa-chart-line"></i>
            </div>
            <div id="graphs_button" className="graphs-button">
              Show Graphs
            </div>
          </div>

          <a href="#" className="video-guide" style={{ fontSize: '12px' }}>
            <span style={{ fontSize: '14px' }}><i id="youtube-icon" className="fa-brands fa-youtube"></i>
            </span> Video Guide
          </a>
        </div>



        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
        {/* TOp section filter  THE END*/}
        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
        {/* Number of data display filter  */}
        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}




        <div className="table-footer" style={{ fontSize: '14px', height: '40px', boxShadow: '0 4px 8px #0000001a' }}>
          <p style={{ fontSize: '14px' }}>Show</p>
          <select style={{ padding: '5px', fontSize: '14px', borderRadius: '3px', borderColor: '#D3D3D3', fontFamily: 'Open Sans, sans-serif' }}>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          Campaigns per page out of {campaigns.length}
        </div>




        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
        {/* Number of data display filter  THE END*/}
        {/* --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


        <div className="campaign-table-container" style={{ boxShadow: '0 4px 8px #0000001a' }}>


          {/* Check if no data and show a message */}
          {noData ? (
            <div className="no-data-message">No data available for the selected date range.</div>
          ) : (
            <table className="campaign-table" >
              <thead style={{ borderBottom: '3px solid #1173B7', textAlign: 'left' }}>
                <tr className='colortd'>
                  <th>Actions</th>
                  <th >Status</th>
                  <th>
                    Ad Format
                    <i
                      className="fa fa-sort-desc"
                      id={'3'}
                      style={{ margin: '0px 4px', color: colors['3'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('3')} // Pass the id to handleClick
                    ></i>
                  </th>
                  <th>ID
                    <i
                      className="fa fa-sort-desc"
                      id={'4'}
                      style={{ margin: '0px 4px', color: colors['4'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('4')} // Pass the id to handleClick
                    ></i>
                  </th>
                  <th>Campaign Name
                    <i
                      className="fa fa-sort-desc"
                      id={'5'}
                      style={{ margin: '0px 4px', color: colors['5'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('5')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Your Bid US$
                    <i
                      className="fa fa-sort-desc"
                      id={'6'}
                      style={{ margin: '0px 4px', color: colors['6'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('6')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>GEO
                    <i
                      className="fa fa-sort-desc"
                      id={'7'}
                      style={{ margin: '0px 4px', color: colors['7'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('7')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Bid Requests
                    <i
                      className="fa fa-sort-desc"
                      id={'8'}
                      style={{ margin: '0px 4px', color: colors['8'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('8')} // Pass the id to handleClick
                    ></i>
                  </th>
                  <th>Video Imp.
                    <i
                      className="fa fa-sort-desc"
                      id={'9'}
                      style={{ margin: '0px 4px', color: colors['9'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('9')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Visits
                    <i
                      className="fa fa-sort-desc"
                      id={'10'}
                      style={{ margin: '0px 4px', color: colors['10'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('10')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Win Rate
                    <i
                      className="fa fa-sort-desc"
                      id={'11'}
                      style={{ margin: '0px 4px', color: colors['11'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('11')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Cost
                    <i
                      className="fa fa-sort-desc"
                      id={'12'}
                      style={{ margin: '0px 4px', color: colors['12'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('12')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <th>Daily Cap
                    <i
                      className="fa fa-sort-desc"
                      id={'13'}
                      style={{ margin: '0px 4px', color: colors['13'] }} // Use the color based on id
                      aria-hidden="true"
                      onClick={() => handleClick('13')} // Pass the id to handleClick
                    ></i>

                  </th>
                  <div style={{ textAlign: 'center', marginTop: '-33px' }}>
                    <p
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#527196',
                        borderBottom: '0.1px solid rgba(82, 113, 150, 0.53)',

                      }}
                    >Conversion</p>
                    <th style={{ width: '61.7%' }}>
                      Total
                      <i
                        className="fa fa-sort-desc"
                        id={'14'}
                        style={{ margin: '0px 2px', color: colors['14'] }} // Use the color based on id
                        aria-hidden="true"
                        onClick={() => handleClick('14')} // Pass the id to handleClick
                      ></i>
                    </th>
                    <th style={{ width: '100%', borderRight: 'none' }}>
                      Rate
                      <i
                        className="fa fa-sort-desc"
                        id={'4'}
                        style={{ margin: '0px 0px', color: colors['4'] }} // Use the color based on id
                        aria-hidden="true"
                        onClick={() => handleClick('4')} // Pass the id to handleClick
                      ></i>
                    </th>
                  </div>
                </tr>
              </thead>
              <tbody >
                {campaigns.map((campaign, index) => {

                  const { totalVisitors, totalBidRequests, totalCost, winRate } = aggregateMetrics(campaign);
                  return (
                    <tr
                      key={campaign.id}
                      className="tbodyhover"
                      onClick={() => handleRowClick(index)} // Handle click event
                      style={{
                        position: 'relative',
                        backgroundColor: campaign.id % 2 === 0 ? 'white' : 'rgba(243, 243, 243, 0.5)',
                      }}
                    >

                      <td style={{ width: '150px' }}>
                        <div className='ActiosIcon' style={{ display: "flex", alignContent: 'center', textAlign: 'center', gap: '2px', margin: 'auto' }}>
                          <i style={{
                            cursor: 'n-resize',
                            color: 'rgba(80,80,80,0.5)',
                            padding: '4px 5px',
                            fontSize: '11px'
                          }}
                            className="fa fa-bars"></i>
                          <i
                            className="fa fa-step-forward"
                            aria-hidden="true"
                            style={{
                              color: 'red',
                              fontSize: '11px',
                              overflow: 'hidden',
                              opacity: '0.3',
                              padding: '4px 5px',
                            }}
                          ></i>

                          <i
                            className="fa fa-pencil fa-fw"
                            aria-hidden="true"
                            style={{
                              color: '#527196',
                              padding: '4px 5px',
                              cursor: "pointer",
                              fontSize: '11px'
                            }}
                            title="Edit"
                            onClick={() => handleCreativePopup(campaign.id, campaign.ad_format)} // Pass adFormat
                          ></i>


                          <i
                            className="fa fa-copy fa-fw"
                            aria-hidden="true"
                            style={{
                              color: '#527196',
                              padding: '4px 5px',
                              fontSize: '11px'
                            }}
                            title="Duplicate"
                          ></i>


                          <i
                            className="fa fa-archive fa-fw"
                            aria-hidden="true"
                            style={{
                              cursor: 'pointer',
                              color: '#527196',
                              padding: '4px 5px',
                              fontSize: '11px'
                            }}

                            title="Archive Campaign"
                            onClick={() => handleDelete(campaign.id)}
                          ></i>

                          <button
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#155C93',
                              cursor: 'pointer',
                              marginTop: '-20px'
                            }}
                            onClick={() => handleEdit(campaign.id)}
                          >
                            <div
                              // name="More_button"
                              title="Advanced Settings"
                              id={`more_funcs_${campaign.id}`}
                              style={{ position: "relative", margin: "4px 0 0 2px" }}
                              onMouseOver={() => handleMouseOver(campaign.id)}
                              onMouseOut={() => handleMouseOut(campaign.id)}
                              onClick={() => handleEdit(campaign.id)}
                            >
                              <i
                                className="fa fa-cog"
                                id={`cog1_${campaign.id}`}
                                aria-hidden="true"
                                style={{
                                  color: "#527196",
                                  position: "absolute",
                                  top: "0",
                                  left: "14px",
                                  fontSize: "7px",
                                }}
                              ></i>
                              <i
                                className="fa fa-cog"
                                id={`cog2_${campaign.id}`}
                                aria-hidden="true"
                                style={{
                                  color: "#527196",
                                  position: "absolute",
                                  top: "9px",
                                  left: "15px",
                                  fontSize: "8px",
                                }}
                              ></i>
                              <i
                                className="fa fa-cog"
                                id={`cog3_${campaign.id}`}
                                aria-hidden="true"
                                style={{
                                  color: "#527196",
                                  position: "absolute",
                                  top: "2px",
                                  left: "3px",
                                  fontSize: "14px",
                                }}
                              ></i>

                            </div>
                          </button>
                        </div>

                      </td>
                      <td className='ActiosIcon' >





                        {/* In this need to add popup that is missing  */}

                        <i
                          className={campaign.ad_format === "In-Page Push Ad" ? "fa fa-file-text" : "fa fa-check-circle"}
                          aria-hidden="true"
                          style={{
                            padding: "4px 5px",
                            minWidth: "13px",
                            fontSize: "14px",
                            color: campaign.ad_format === "In-Page Push Ad" ? "orange" : "#527196", // Default color
                          }}
                          title={`Editorial Status: Approved`}
                        ></i>


                        <img
                          src={mycompass}
                          style={{ cursor: 'pointer', width: '13px', height: '13px', color: '#527196', marginLeft: '8px', marginTop: '5px' }}

                        />
                        <i
                          className="fa fa-stethoscope fa-fw"
                          aria-hidden="true"
                          style={{
                            color: '#527196',
                            padding: '4px 5px',
                            fontSize: '13px'
                          }}
                          title="Campaign Health Analysis"
                        // onClick={handleClick}
                        ></i>

                        {/* In this need to add popup that is missing  */}

                        <i
                          className="fa fa-exclamation-triangle"
                          id="NOSRCCLICKID837203"
                          style={{
                            padding: '4px 7px',
                            fontSize: '13px',
                            zIndex: 4,
                            color: 'orange',
                          }}
                          // onClick={handleClick}
                          title="Campaign Alert"
                          aria-hidden="true"
                        ></i>
                      </td>

                      <td>
                        <div style={{ display: 'flex', gap: '10px', textTransform: 'capitalize' }} className='ActiosIcon'>
                          <div className='custom-circle '>
                            M
                          </div>
                          <i className='fa fa-desktop '></i>
                          {campaign.ad_format}

                        </div>

                      </td>

                      <td>{campaign.id}</td>



                      <td style={{ width: '15%' }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            width: "100%", // Ensure full width
                            justifyContent: "space-between", // Move last element to end
                          }}
                          className="ActiosIcon"
                        >
                          <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                            <img src={campaignicon} alt="" style={{ width: "15px", height: "13px" }} />

                            {/* Campaign Name with Click Effect */}
                            <span
                              className="campaign-name"
                              onClick={() => handleClick2(campaign.id)}
                              style={{ cursor: "pointer" }}
                            >
                              {campaign.campaign_name}
                            </span>
                          </div>

                          {/* Display the additional icon only when the clicked campaign ID matches */}
                          {selectedId === campaign.id && (
                            <img src={fasend} alt="" style={{ width: "18px", height: "15px" }} />
                          )}
                        </div>
                      </td>

                      <td>
                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                          {/* <i style={{ color: '#FEAA15' }} className='fa fa-exclamation-triangle'></i> */}
                          <div style={{ color: '#81D34A', fontWeight: '500' }}>
                            <p style={{ color: '#62a535', fontSize: '13px', fontWeight: '400' }}>$</p>
                          </div>
                          <div className='BidBorder' >
                            {Number(campaign.bid).toFixed(2)}
                          </div>

                        </div>

                      </td>

                      <td style={{ textAlign: 'left' }}>
                        {campaign.geo.includes(',') ? ( // Check if there are multiple cities
                          <div
                            style={{ display: 'flex', gap: '10px', textTransform: 'capitalize' }}
                            className="ActiosIcon"
                          >
                            <img
                              src={myimg}
                              style={{ cursor: 'pointer', width: '16px', height: '14px', color: '#527196' }}
                              onMouseEnter={() => handleMouseEnter(index)} // Handle hover on icon
                              onMouseLeave={handleMouseLeave}
                              alt=""
                            />

                            {hoveredIndex === index && (
                              <div
                                style={{
                                  position: 'absolute',
                                  width: 'auto',
                                  maxWidth: '100px',
                                  minWidth: '100px',
                                  height: 'auto',
                                  textAlign: 'center',
                                  borderRadius: '10px',
                                  top: '0',
                                  left: '43.5%',
                                  backgroundColor: 'white',
                                  border: '1px solid #527196',
                                  padding: '5px',
                                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                  fontFamily: 'Courier',
                                  zIndex: 10,
                                  whiteSpace: 'normal',
                                  wordWrap: 'break-word',
                                  alignItems: 'center',
                                  paddingTop: '10px',
                                  overflow: 'visible'
                                }}
                              >
                                {campaign.geo}
                              </div>
                            )}
                          </div>
                        ) : (
                          <span style={{ textDecoration: 'underline' }}>{campaign.geo}</span>
                        )}
                      </td>


                      <td>
                        {["Video Ad"].includes(campaign.ad_format)
                          ? '-'
                          : new Intl.NumberFormat('en-US').format(Number(totalBidRequests))}
                      </td>
                      <td>
                        {["Video Ad"].includes(campaign.ad_format)
                          ? new Intl.NumberFormat('en-US').format(Number(totalBidRequests))
                          : '-'}
                      </td>

                      <td>{new Intl.NumberFormat('en-US').format(totalVisitors)}</td>

                      <td>
                        {winRate}
                      </td>


                      <td>${totalCost.toFixed(2)}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between", // Ensures fasend icon moves to the end
                            width: "100%", // Ensures full width
                          }}
                        >
                          {/* Left Section (Dollar Sign + Bid Amount) */}
                          <div
                            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                            onClick={() => handleClick3(campaign.id)}
                          >
                            <div style={{ color: "#81D34A", fontWeight: "500", marginRight: "5px" }}>
                              <p>$</p>
                            </div>
                            <div className="BidBorder" style={{ height: "30px" }}>
                              {Number(campaign.daily_cap).toFixed(2)}
                            </div>
                          </div>

                          {/* Display the additional icon only when the clicked campaign ID matches */}
                          {selectedId2 === campaign.id && (
                            <img src={fasend} alt="" style={{ width: "15px", height: "13px" }} />
                          )}
                        </div>
                      </td>


                      <td></td>
                    </tr>
                  );

                })}


                <tr>
                  <td>
                    <div title="Pause all" style={{ padding: '2px 5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div>
                        <i
                          className="fa fa-step-forward"
                          aria-hidden="true"
                          style={{ color: '#fc7c7c', fontSize: '12px' }}
                        ></i>
                        {/* <i
                          className="fa fa-pause"
                          aria-hidden="true"
                          style={{ color: '#fc7c7c'}}
                        ></i> */}
                      </div>

                      <a
                        href="#"
                        style={{ float: 'left', fontSize: '14px', color: '#505050' }}
                        onClick={(e) => {
                          e.preventDefault();

                        }}
                      >
                        Pause all
                      </a>
                    </div>


                  </td>


                  <td>
                    <div title="Pause all" style={{ padding: '2px 5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div>
                        <i
                          className="fa fa-step-forward"
                          aria-hidden="true"
                          style={{ color: '#fc7c7c', fontSize: '12px' }}
                        ></i>
                        {/* <i
                          className="fa fa-pause"
                          aria-hidden="true"
                          style={{ color: '#fc7c7c'}}
                        ></i> */}
                      </div>

                      <a
                        href="#"
                        style={{ float: 'left', fontSize: '14px', color: '#505050' }}
                        onClick={(e) => {
                          e.preventDefault();

                        }}
                      >
                        Resume all
                      </a>
                    </div>


                  </td>


                  <td colSpan={3}>
                    {/* Actions Header */}
                    <div className="table-actions" style={{ alignItems: 'center', alignContent: 'center', padding: '0px' }}>
                      <p>Re-Order Table:</p>
                      <button className="btn-save" onClick={saveDataAsCSV} style={{ margin: '3px', backgroundColor: 'transparent', color: 'gray', border: 'none', display: 'flex' }}>
                        <img src={floppy} alt="" style={{ color: 'rgba(80,80,80,0.3)', marginRight: '5px', width: '13px' }} />
                        Save
                      </button>
                      <button className="btn-red" onClick={clearData} style={{ margin: '3px', backgroundColor: 'transparent', color: 'gray', display: 'flex' }}>

                        <img src={undo} alt="" style={{ color: 'rgba(80,80,80,0.3)', marginRight: '5px', width: '13px' }} />
                        Clear
                      </button>


                    </div>
                  </td>
                  <td colSpan={2} style={{ textAlign: 'right' }}><strong>Total</strong></td>
                  <td>
                    {Intl.NumberFormat('en-US').format(Number(totals.totalBidRequestsNonVideo))}
                  </td>
                  <td>
                    {Intl.NumberFormat('en-US').format(Number(totals.totalBidRequestsVideo))}
                  </td>
                  <td>
                    {Intl.NumberFormat('en-US').format(Number(totals.totalVisitors))}
                  </td>
                  <td>
                    {/* {Intl.NumberFormat('en-US').format(Number(totals.totalWinRate.toFixed(2)))}% */}
                  </td>
                  <td>
                    ${Intl.NumberFormat('en-US').format(Number(totals.totalCost))}
                  </td>

                  <td>
                    {/* ${totals.totalDailyCap.toFixed(2)} */}
                  </td>
                  <div>
                    <td className='padrate2' >0</td>
                    <td className='padrate'></td>
                  </div>

                </tr>



              </tbody>
            </table>

          )}

          {/* Pagination */}

        </div>
        {isEditModalOpen && currentEditId1 !== null && (
          <div
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Background overlay
              backdropFilter: 'blur(8px)',  // Apply blur effect to the background
              WebkitBackdropFilter: 'blur(8px)', // Safari support
              zIndex: 1000000, // Ensure it's on top of other content
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              className="modal"
              style={{
                position: 'relative',
                background: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 1000001, // Ensure modal is above the blur effect
                width: '60%',
                height: '70%',
                overflowY: 'auto', // Enables vertical scrolling
                overflowX: 'hidden', // Prevents horizontal scrolling
              }}
            >
              <button
                onClick={() => setIsEditModalOpen(false)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                }}
              >
                &times; {/* Close Icon */}
              </button>

              <PopupMultiform
                recordId={currentEditId1} // Pass the correct ID here
                handleClose={() => setIsEditModalOpen(false)}
                onUpdate={fetchData}
              />
            </div>
          </div>
        )}

        {isEditModalOpen1 && currentEditId !== null && (
          <div
            className="modal-background"
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Background overlay
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              zIndex: 1000000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* Close Button - Now outside the modal box */}
            <button
              onClick={handleCloseEditModal}
              style={{
                position: 'absolute',
                top: '14%',  // Adjust based on your design
                right: '19.2%',
                background: 'black',
                border: '2px solid white',
                fontSize: '20px',
                cursor: 'pointer',
                color: 'white',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
                zIndex: 1000002,  // Ensure it’s above everything
              }}
            >
              ×
            </button>

            <div
              className="modal"
              style={{
                position: 'relative',
                background: 'white',
                padding: '0px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 1000001,
                width: '60%',
                height: '70%',
                overflowY: 'hidden',
                
                 
              }}
            >
              <div
                style={{
                  height: '100%',
                  overflowY: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
                className="scrollable-content"
              >
                <style>
                  {`
         .scrollable-content::-webkit-scrollbar {
           display: none;
         }
       `}
                </style>

                {/* Conditional Rendering for Ad Type */}
                {currentAdFormat !== "Video Ad" &&
                  currentAdFormat !== "Native Ad" &&
                  currentAdFormat !== "In-Page Push Ad" ? (
                  <CreativeStepPopup
                    recordId={currentEditId}
                    handleClose={() => setIsEditModalOpen1(false)}
                    onUpdate={fetchData}
                  />
                ) : (
                  <CreativeStepPopup2
                    recordId={currentEditId}
                    handleClose={() => setIsEditModalOpen1(false)}
                    onUpdate={fetchData}
                  />
                )}
              </div>
            </div>
          </div>
        )}





        {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------------ */}


        <div className="table-footer" style={{ fontSize: '14px', justifyContent: 'space-between', height: '24px', boxShadow: '0 4px 8px #0000001a' }}>

          <div style={{ display: 'flex', alignContent: 'center', alignItems: 'center', gap: '10px' }}>
            <select style={{ padding: '10px', borderRadius: '3px', color: '#505050', borderColor: '#D3D3D3' }}>
              <option value="50">All Campaigns</option>
              <option value="100">Displayed Campaigns</option>
              <option value="100">Current Page</option>

            </select>
          </div>

          <div style={{ display: 'flex', alignContent: 'center', alignItems: 'center', gap: '10px' }}>
            <p style={{ fontSize: '12px' }}>Show</p>
            <select style={{ padding: '10px', borderRadius: '3px', borderColor: '#D3D3D3' }}>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            Campaigns per page out of {campaigns.length}
          </div>

        </div>


        {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------------ */}

      </div>
    </>
  );
};

export default DefaultPage;
